import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../../lib/api';
import { Logo } from '../../components/ui/logo';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';

/**
 * Ziel des Links aus der Reset-Mail für Mitarbeiter (T-0131):
 * `{officeBaseUrl}/reset-password?key=…`. Die Seite fehlte, der Link endete auf dem Login.
 */
const PasswortZuruecksetzen = () => {
  const [params] = useSearchParams();
  const key = params.get('key') || '';
  const [passwort, setPasswort] = useState('');
  const [wiederholung, setWiederholung] = useState('');
  const [fehler, setFehler] = useState('');
  const [laeuft, setLaeuft] = useState(false);
  const [fertig, setFertig] = useState(false);

  const absenden = async (e: React.FormEvent) => {
    e.preventDefault();
    setFehler('');
    if (passwort.length < 8) {
      setFehler('Das Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }
    if (passwort !== wiederholung) {
      setFehler('Die Passwörter stimmen nicht überein.');
      return;
    }
    setLaeuft(true);
    try {
      await api.post('/api/auth/reset-password', { key, password: passwort });
      setFertig(true);
    } catch {
      setFehler('Der Link ist ungültig oder abgelaufen. Fordere bitte einen neuen an.');
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <Logo size="lg" />
          </div>
          <h2 className="mt-2 text-xl font-semibold">Neues Passwort vergeben</h2>
        </div>

        {!key ? (
          <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive text-center">
            Der Link ist unvollständig. Fordere bitte einen neuen an.
          </div>
        ) : fertig ? (
          <div className="space-y-4">
            <div className="rounded-md border p-4 text-sm">
              Dein Passwort ist geändert. Du kannst dich jetzt damit anmelden.
            </div>
            <Button asChild className="w-full">
              <Link to="/login">Zur Anmeldung</Link>
            </Button>
          </div>
        ) : (
          <form className="space-y-4" onSubmit={absenden}>
            <div>
              <label htmlFor="passwort" className="block text-sm font-medium">
                Neues Passwort
              </label>
              <Input
                id="passwort"
                type="password"
                autoComplete="new-password"
                value={passwort}
                onChange={(e) => setPasswort(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="wiederholung" className="block text-sm font-medium">
                Passwort wiederholen
              </label>
              <Input
                id="wiederholung"
                type="password"
                autoComplete="new-password"
                value={wiederholung}
                onChange={(e) => setWiederholung(e.target.value)}
              />
            </div>
            {fehler && <p className="text-sm text-destructive">{fehler}</p>}
            <Button type="submit" className="w-full" disabled={laeuft}>
              {laeuft ? 'Wird gespeichert...' : 'Passwort speichern'}
            </Button>
          </form>
        )}

        <div className="text-center text-sm space-x-4">
          <Link to="/forgot-password" className="font-medium text-primary hover:underline">
            Neuen Link anfordern
          </Link>
          <Link to="/login" className="font-medium text-primary hover:underline">
            Zur Anmeldung
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PasswortZuruecksetzen;
